import React from 'react';

/* The sprite has no per-network item artwork, so every brand renders the same glyph.
 * The surrounding badge is styled per brand in less/app/<brand>.less if needed.
 */
export default function Gift() {
  return (
    <div>
      <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_gift" /></svg>
    </div>
  );
}
